/** Development-only transport for authenticated uploads through the GCP API. */
export function getLocalGcpUploadProxyEndpoint(endpoint: string, method: string): string | null {
  if (
    process.env.NODE_ENV !== 'development'
    || process.env.NEXT_PUBLIC_LOCAL_GCP_IMAGE_UPLOAD !== 'true'
    || process.env.NEXT_PUBLIC_LOCAL_GCP_SIGNED_OBJECT_UPLOAD === 'true'
    || method.toUpperCase() !== 'POST'
  ) return null;

  if (endpoint === '/upload/image') return '/api/local-gcp-image-upload';
  const consultationUpload = /^\/canvas-chat\/consultation\/documents(\/(?:from-asset|presign-upload|confirm-upload))?(\?.*)?$/.exec(endpoint);
  if (consultationUpload) {
    return `/api/local-gcp-consultation-documents${consultationUpload[1] || ''}${consultationUpload[2] || ''}`;
  }
  const materialUpload = /^\/materials\/(presign-upload|confirm-upload)(\?.*)?$/.exec(endpoint);
  return materialUpload
    ? `/api/local-gcp-material-upload/${materialUpload[1]}${materialUpload[2] || ''}`
    : null;
}

/** Keep the cloud-issued signature intact while uploading from a local origin. */
export function getLocalGcpSignedUploadUrl(uploadUrl: string): string {
  const objectOnly = process.env.NEXT_PUBLIC_LOCAL_GCP_SIGNED_OBJECT_UPLOAD === 'true';
  if (process.env.NODE_ENV !== 'development'
    || (!objectOnly && process.env.NEXT_PUBLIC_LOCAL_GCP_IMAGE_UPLOAD !== 'true')) return uploadUrl;

  try {
    const url = new URL(uploadUrl);
    const bucketPrefix = '/dobidobi-user-assets-asia-east1/';
    if (url.origin !== 'https://storage.googleapis.com'
      || url.username || url.password || url.hash
      || !url.pathname.startsWith(bucketPrefix)
      || !url.searchParams.has('X-Goog-Signature')) return uploadUrl;

    const prefix = objectOnly ? '/api/local-signed-gcs-object/' : '/api/local-gcp-material-object/';
    return `${prefix}${url.pathname.slice(bucketPrefix.length)}${url.search}`;
  } catch {
    return uploadUrl;
  }
}
